import { Component } from "@angular/core";
import { AbstractModal } from "src/app/shared/components/modal/abstractModal";

@Component({
    selector: "oe-controller-ess-grid-optimized-charge-history",
    templateUrl: "./new-navigation.html",
    standalone: false,
})
export class ControllerEssGridOptimizedChargeHistoryComponent extends AbstractModal { }
